require("../node_modules/angular/angular");
require("../node_modules/angular-sanitize/angular-sanitize");
require("../node_modules/angular-animate/angular-animate");
require("../node_modules/angular-touch/angular-touch");
require("../node_modules/angular-cookies/angular-cookies");
require("./ui-bootstrap-tpls.min");
require("./simplemde-angular.min");
require("./modules/paginate");
require("../node_modules/ng-showdown/dist/ng-showdown");
require("../node_modules/angular-toastr/dist/angular-toastr.tpls");
require("../node_modules/ng-file-upload/dist/ng-file-upload-all.min");

import {Utilities} from "./utilities/Utilities";

Utilities.init();

import {ModalInstance} from "./controllers/ModalInstance";
import {Encounter} from "./controllers/Encounter";
import {SpellsView} from "./controllers/SpellsView";
import {SpellsEdit} from "./controllers/SpellsEdit";
import {MysticView} from "./controllers/MysticView";
import {FeatureInstance} from "./controllers/FeatureInstance";
import {LootRoller} from "./controllers/LootRoller";
import {Trans} from "./controllers/Trans";
import {TreasureRoller} from "./controllers/TreasureRoller";
import {TreasureShow} from "./controllers/TreasureShow";
import {ItemEditor} from "./controllers/ItemEditor";
import {ItemViewer} from "./controllers/ItemViewer";
import {ItemInstance} from "./controllers/ItemInstance";
import {Calculator} from "./controllers/Calculator";

let myapp = angular.module("dndhelper", ['simplemde','ngSanitize','ui.bootstrap','toastr','angularUtils.directives.dirPagination','ng-showdown','ngFileUpload'])
    .config(function($interpolateProvider) {
    $interpolateProvider.startSymbol('``');
    $interpolateProvider.endSymbol('``');
});

myapp.controller('ModalInstanceCtrl', ModalInstance);
myapp.controller('Encounter',Encounter);
myapp.controller('SpellsView',SpellsView);
myapp.controller('SpellsEdit',SpellsEdit);
myapp.controller('MysticView',MysticView);
myapp.controller('FeatureModalCtrl',FeatureInstance);
myapp.controller('ItemInstance',ItemInstance);
myapp.controller('LootRoller', LootRoller);
myapp.controller('TreasureRoller', TreasureRoller);
myapp.controller('Trans', Trans);
myapp.controller('TreasureShow', TreasureShow);
myapp.controller('ItemEditor',ItemEditor);
myapp.controller('ItemViewer',ItemViewer);
myapp.controller('Calculator',Calculator);

myapp.directive('custom-simplemde', [function () {
    return {
        restrict: 'A',
        require: 'simplemde',
        link: function (scope, element, attrs, simplemde) {
            simplemde.get(); // => SimpleMDE instance
            simplemde.rerenderPreview();
        }
    }
}]);

require('./modules/templates');

myapp.directive('spelllist', function () {
    return {
        restrict: 'E',
        link: function (scope, element, attrs) {
            scope.contentUrl =  attrs.type + '.html';
            attrs.$observe("type", function (v) {
                scope.contentUrl =  v + '.html';
            });
        },
        template: '<div ng-include="contentUrl"></div>'
    }
});


